// extracted by mini-css-extract-plugin
module.exports = {"title":"edit_amount__title___2-fe6 _type__vx_text-2___Qizsf","save-button":"edit_amount__save-button___3Iwit"};